import { FC, useEffect, useRef } from 'react';

import { LogoVideoCallIcon } from '../../icons/logo-videocall';

import { Trajectory } from '../../../hooks/useDpdgState';
import { IYandexPlayerHandle } from './YandexVideo';
import DpDgBall from './DpDgBall';

export interface IDpDgVideoPanelProps {
  roomName?: string;
  bgColor: string;
  ballColor: string;
  velocity: number;
  trajectory: Trajectory;
  changeTrajectory: (trajectory: Trajectory) => void;
  backgroundType: 'none' | 'video' | 'image';
  backgroundValue: string;
  ballSize: number;
  sendDpdgVideoControl?: (payload: { type: string; time?: number }) => void;
  sendDpdgMessage?: (action: string, data: Record<string, unknown>) => void;
  useDataChannelToolTransport?: boolean;
  /** Мобильный 1:1: поле на весь экран без скруглений и логотипа (логотип перекрывался бы превью видео) */
  mobile?: boolean;
}

export const DpDgVideoPanelPsy: FC<IDpDgVideoPanelProps> = ({
  roomName,
  ballColor,
  bgColor,
  trajectory,
  changeTrajectory,

  velocity,
  backgroundType,
  backgroundValue,
  ballSize,
  sendDpdgVideoControl,
  sendDpdgMessage,
  useDataChannelToolTransport,
  mobile = false,
}) => {
  const yandexPlayerRef = useRef<IYandexPlayerHandle>(null);
  const safeRoomId = roomName ?? '';

  useEffect(() => {
    if (!yandexPlayerRef.current) return;

    const player = yandexPlayerRef.current;

    const handleStatusChange = ({ status }: { status: string }) => {
      if (status === 'play' || status === 'pause') {
        const data: { type: string; time?: number } = { type: status };
        if (status === 'play') {
          const current = player?.getState?.().currentTime;
          if (typeof current === 'number') {
            data.time = current;
          }
        }
        if (sendDpdgVideoControl) {
          sendDpdgVideoControl(data);
        }
      }
    };

    let lastSeekTime = 0;
    const handleSeek = ({ currentTime }: { currentTime: number }) => {
      if (Math.abs(currentTime - lastSeekTime) > 5000) {
        lastSeekTime = currentTime;
        const payload = { type: 'seek', time: currentTime };
        if (sendDpdgVideoControl) {
          sendDpdgVideoControl(payload);
        }
      }
    };

    player?.on?.('StatusChange', handleStatusChange);
    player?.on?.('CurrentTimeChange', handleSeek);

    return () => {
      player?.off?.('StatusChange', handleStatusChange);
      player?.off?.('CurrentTimeChange', handleSeek);
      if (yandexPlayerRef.current) yandexPlayerRef.current?.stop();
    };
  }, [safeRoomId, sendDpdgVideoControl]);

  return (
    <div
      className={
        mobile ? 'relative h-full w-full overflow-hidden' : 'relative w-full h-full overflow-hidden rounded-card'
      }
    >
      <DpDgBall
        trajectory={trajectory}
        isPsychologist={true}
        roomId={safeRoomId}
        bgColor={bgColor}
        ballColor={ballColor}
        velocity={velocity}
        backgroundType={backgroundType}
        backgroundValue={backgroundValue}
        ballSize={ballSize}
        changeTrajectory={changeTrajectory}
        sendDpdgMessage={sendDpdgMessage}
        useDataChannelToolTransport={useDataChannelToolTransport}
        compactControls={mobile}
      />
      {!mobile && (
        <div className="absolute top-[15px] right-[15px] w-[89px] h-[25px] lg:w-[172px] lg:h-[50px]">
          <LogoVideoCallIcon className="w-full h-full" />
        </div>
      )}
    </div>
  );
};
